export default __webpack_public_path__ + "sales_per_dosh_subscriber.png";